import { render, staticRenderFns } from "./ProgrammeDoublonModal.vue?vue&type=template&id=2805a09a&scoped=true&"
import script from "./ProgrammeDoublonModal.vue?vue&type=script&lang=js&"
export * from "./ProgrammeDoublonModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2805a09a",
  null
  
)

export default component.exports